import { FETCH_AUCTION_META } from "../actionTypes";


export const fetchItemMeta = payload => ({
    type: FETCH_AUCTION_META,
    payload
});
